export default "__VITE_ASSET__C6ha_Wje__"